/**
 * Frenet
 * Cálculo de frete
 * Hera Eyewear
 */

(function () {
  'use strict';

   const FRENET_PROXY_URL = 'https://shipping.heraeyewear.com.br';
  const CEP_ORIGEM       = '30130004';

  // Peso padrão em kg quando não disponível no produto
  const DEFAULT_WEIGHT_KG = 1;
  // Dimensões padrão em cm (caixa de óculos Hera)
  const DEFAULT_DIMENSIONS = { height: 7.5, length: 22.5, width: 22.5 };

  function sanitizeCep(cep) {
    return cep.replace(/\D/g, '');
  }

  function maskCep(value) {
    const digits = sanitizeCep(value).slice(0, 8);
    return digits.length > 5 ? digits.slice(0, 5) + '-' + digits.slice(5) : digits;
  }

  function formatMoney(value) {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format(value);
  }

  async function getCartItems() {
    const res  = await fetch('/cart.js');
    const cart = await res.json();
    return cart.items.map((item) => ({
      weight:   (item.grams || DEFAULT_WEIGHT_KG * 1000) / 1000,
      price:    item.price / 100,
      quantity: item.quantity,
      ...DEFAULT_DIMENSIONS,
    }));
  }

  function buildPayload(cepDestino, items) {
    return {
      SellerCEP:              CEP_ORIGEM,
      RecipientCEP:           cepDestino,
      ShipmentInvoiceValue:   items.reduce((sum, i) => sum + i.price * i.quantity, 0),
      ShippingItemArray:      items.map((item) => ({
        Height:   item.height   || DEFAULT_DIMENSIONS.height,
        Length:   item.length   || DEFAULT_DIMENSIONS.length,
        Quantity: item.quantity,
        Weight:   item.weight   || DEFAULT_WEIGHT_KG,
        Width:    item.width    || DEFAULT_DIMENSIONS.width,
        SKU:      'PRODUTO',
        Category: 'Acessorios',
      })),
    };
  }

  async function fetchFrenet(payload) {
    const res = await fetch(FRENET_PROXY_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    if (!res.ok) throw new Error('Erro ao consultar frete.');
    const data = await res.json();
    return data.ShippingSevicesArray || data.ShippingServicesArray || [];
  }

  function renderResults(container, services) {
    container.innerHTML = '';

    const valid = services.filter((s) => !s.Error && s.ShippingPrice != null);

    if (valid.length === 0) {
      container.innerHTML = '<div class="frenet-shipping__error">Nenhuma opção de frete disponível para este CEP.</div>';
      return;
    }

    valid.forEach((service) => {
      const isFree     = service.ShippingPrice === 0;
      const priceText  = isFree ? 'Grátis' : formatMoney(service.ShippingPrice);
      const priceClass = isFree
        ? 'frenet-shipping__price frenet-shipping__price--free'
        : 'frenet-shipping__price';
      const deadline   = service.DeliveryTime > 0
        ? `${service.DeliveryTime} dia${service.DeliveryTime > 1 ? 's úteis' : ' útil'}`
        : '';

      const item = document.createElement('div');
      item.className = 'frenet-shipping__result-item';
      item.innerHTML = `
        <span class="frenet-shipping__carrier">${service.ServiceDescription}</span>
        ${deadline ? `<span class="frenet-shipping__deadline">${deadline}</span>` : ''}
        <span class="${priceClass}">${priceText}</span>
      `;
      container.appendChild(item);
    });
  }

  function initWidget(widget) {
    const context   = widget.dataset.context;
    const input     = widget.querySelector('.frenet-shipping__input');
    const button    = widget.querySelector('.frenet-shipping__button');
    const resultsEl = widget.querySelector('.frenet-shipping__results');

    if (!input || !button || !resultsEl) return;

    input.addEventListener('input', () => {
      input.value = maskCep(input.value);
    });

    input.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') button.click();
    });

    // Restaura CEP salvo e calcula automaticamente
    const savedCep = localStorage.getItem('frenet_cep');
    if (savedCep) {
      input.value = maskCep(savedCep);
      button.click();
    }

    button.addEventListener('click', async () => {
      const cep = sanitizeCep(input.value);

      // Salva CEP para uso futuro
      if (cep.length === 8) localStorage.setItem('frenet_cep', cep);

      if (cep.length !== 8) {
        resultsEl.innerHTML = '<div class="frenet-shipping__error">Digite um CEP válido com 8 dígitos.</div>';
        return;
      }

      button.disabled = true;
      resultsEl.innerHTML = '<div class="frenet-shipping__loading">Calculando...</div>';

      try {
        let items;

        if (context === 'cart') {
          items = await getCartItems();
        } else {
          const weightKg = parseFloat(widget.dataset.productWeight) || DEFAULT_WEIGHT_KG;
          const price    = parseFloat(widget.dataset.productPrice)  || 0;
          items = [{
            weight:   weightKg,
            price:    price,
            quantity: 1,
            ...DEFAULT_DIMENSIONS,
          }];
        }

        const payload  = buildPayload(cep, items);
        const services = await fetchFrenet(payload);
        renderResults(resultsEl, services);

      } catch (err) {
        console.error('[Frenet]', err);
        resultsEl.innerHTML = '<div class="frenet-shipping__error">Não foi possível calcular o frete. Tente novamente.</div>';
      } finally {
        button.disabled = false;
      }
    });
  }

  function boot() {
    document.querySelectorAll('.frenet-shipping').forEach(initWidget);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();